export default __webpack_public_path__ + "static/media/dashboard.c5eaa7cf.svg";